const resources = {
    sponsored: 'Sponsored',
    alt: 'Image de bannière avec contenu sponsorisé'
};

module.exports = function getResource(label) {
    return resources[label];
};
